import '@tiptap/extension-text-style';
import { Extension } from '@tiptap/core';
export var FontSize = Extension.create({
    name: 'fontSize',
    addOptions: function () {
        return {
            types: ['textStyle']
        };
    },
    addGlobalAttributes: function () {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontSize: {
                        default: null,
                        parseHTML: function (element) { var _a; return (_a = element.style.fontSize) === null || _a === void 0 ? void 0 : _a.replace(/['"]+/g, ''); },
                        renderHTML: function (attributes) {
                            if (!attributes.fontSize) {
                                return {};
                            }
                            return {
                                style: "font-size: ".concat(attributes.fontSize)
                            };
                        }
                    }
                }
            }
        ];
    },
    addCommands: function () {
        return {
            setFontSize: function (fontSize) {
                return function (_a) {
                    var chain = _a.chain;
                    return chain().setMark('textStyle', { fontSize: fontSize }).run();
                };
            },
            unsetFontSize: function () {
                return function (_a) {
                    var chain = _a.chain;
                    return chain().setMark('textStyle', { fontSize: null }).removeEmptyTextStyle().run();
                };
            }
        };
    }
});
